import React from "react";
import { QueryClientProvider, QueryClient } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ColorModeContext, useMode } from "./theme";
import { ThemeProvider } from "@mui/material/styles";
import { cacheRtl } from "./CustomTheme/CustomTheme";
import { CacheProvider } from "@emotion/react";
import { SnackbarProvider, useSnackbar } from "notistack";
import "./App.css";
import RootRoute from "./Routes/RootRoute";
import DashRoutes from "./Routes/Routes";
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import AdapterJalaali from "@date-io/jalaali";
import ErrorBoundary from "./utils/ErrorBoundray";
import { DashboardSettingProvider } from "./Context/DashboardSettingProvider";
import { DashboardModalsProvider } from "./Context/DashboardModalsContext";
const queryClient = new QueryClient();
function App() {
  const [theme, colorMode] = useMode();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterJalaali} adapterLocale="faIR">
          <ColorModeContext.Provider value={colorMode}>
            <CacheProvider value={cacheRtl}>
              <ThemeProvider theme={theme}>
                <SnackbarProvider maxSnack={3} autoHideDuration={5000}>
                  <DashboardModalsProvider>
                    <DashboardSettingProvider>
                      <CssBaseline />
                      <RootRoute />
                      <DashRoutes />
                    </DashboardSettingProvider>
                  </DashboardModalsProvider>
                </SnackbarProvider>
              </ThemeProvider>
            </CacheProvider>
          </ColorModeContext.Provider>
        </LocalizationProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </>
  );
}

export default App;
